import React from "react";
import { Toaster } from "react-hot-toast";
import styles from "../shared/css/layout.module.scss";
import Sidebar from "../shared/sidebar/Sidebar";
const Layout = ({ children }) => {
  return (
    <>
      <Toaster position="top-center" />

      <Sidebar>
        <>
          <div className={styles.main}>{children}</div>
        </>
      </Sidebar>
    </>
  );
};

export default Layout;
